import { render, staticRenderFns } from "./AiSuggestionMarketingCostParser.vue?vue&type=template&id=696151bc"
import script from "./AiSuggestionMarketingCostParser.vue?vue&type=script&lang=js"
export * from "./AiSuggestionMarketingCostParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports